import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from 'api/common/constants';

const CENTER_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TRACEABILITY,
  VERSIONS.V1,
  RESOURCES.CENTER,
  false
);
export const ProcessingCenterApi = {
  centerForm: () => {
    const url = `${CENTER_BASE}/form`;
    return apiClient.get(url);
  },

  centerEditForm: id => {
    const url = `${CENTER_BASE}/form?is_edit=true&center_id=${id}`;
    return apiClient.get(url);
  },

  createCenter: combinedData => {
    const url = `${CENTER_BASE}`;
    return apiClient.post(url, combinedData);
  },

  updateCenter: (combinedData, id) => {
    const url = `${CENTER_BASE}/${id}`;
    return apiClient.put(url, combinedData);
  }
};
